export const environment = {
    production: true,
    domain: "https://creators.aiva.ai",
    v2Domain: "http://v2.aiva.ai",
    apiURL: "https://api.aiva.creators.aiva.ai",
    socketURL: "wss://socket.aiva.creators.aiva.ai",
    stripe: "pk_live_ANB2mYrsMy8XJjXzzU1qCokV",
    recaptchaSiteKey: "6Lcyra4ZAAAAAEkQ8fn95yfE7exirwST_JTdOPVf",
    googleClientID:
        "1092443158494-32438jdhlih4fbt38cpgr7f7reg259oh.apps.googleusercontent.com",
}
